import { render, staticRenderFns } from "./gateway-order-confirmation-demo.vue?vue&type=template&id=d8a6c0da&scoped=true&"
import script from "./gateway-order-confirmation-demo.vue?vue&type=script&lang=js&"
export * from "./gateway-order-confirmation-demo.vue?vue&type=script&lang=js&"
import style0 from "./gateway-order-confirmation-demo.vue?vue&type=style&index=0&id=d8a6c0da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a6c0da",
  null
  
)

export default component.exports